import { Component, inject, Input } from "@angular/core";
import { ChipsComponent } from "@app/shared/components/dsn/chips/chips.component";
import { TextareaComponent } from "@dsn/textarea/textarea.component";
import { ButtonComponent } from "@dsn/button/button.component";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { InsertReportFeedbackController } from "../../../../../../arch/presentation/controllers/insert-report-feedback.controller";
import { ReportEntity } from "@arch/domain/entity/report.entity";
import { DialogService } from "@app/shared/services/dialog/dialog.service";
import { EventsService } from "@arch/domain/application/services/events.service";
import { ContactService } from "@app/shared/services/contact.service";

@Component({
    selector: "app-report-feedback-form",
    templateUrl: "./report-feedback-form.component.html",
    styleUrl: "./report-feedback-form.component.scss",
    standalone: true,
    imports: [
        ChipsComponent,
        TextareaComponent,
        ButtonComponent,
        FormsModule,
        CommonModule
    ]
})
export class ReportFeedbackFormComponent {
    @Input({ required: true }) report: ReportEntity;

    private readonly contactService = inject(ContactService);

    public contact = this.contactService.get();
    readonly insertReportFeedbackController: InsertReportFeedbackController =
        inject(InsertReportFeedbackController);
    readonly dialogService: DialogService = inject(DialogService);
    private readonly eventsService = inject(EventsService);
    public description: string = "";
    public selectedStars: number = 0;
    public showChips: boolean = false;
    public chips: {
        label: string;
        selected: boolean;
    }[] = [
        {
            label: "Resultados",
            selected: false
        },
        { label: "Encargos", selected: false },
        { label: "Gastos", selected: false },
        {
            label: "Quero Marcar uma reunião",
            selected: false
        }
    ];

    public selectStar(index: number): void {
        this.selectedStars = index + 1;
        this.showChips = true;
    }

    public selectChip(chip: { label: string; selected: boolean }): void {
        chip.selected = !chip.selected;
    }

    public async onSubmit(): Promise<void> {
        this.eventsService.send(
            `Dash.${this.report.type}.${this.report.humanSourceName}.feedback`
        );
        const selectedChips = this.chips.filter((chip) => chip.selected);

        await this.insertReportFeedbackController.execute({
            _id: this.report.props._id,
            feedback: {
                score: this.selectedStars,
                comment: this.description,
                userId: this.contact.props._id,
                opinion: selectedChips.map((chip) => chip.label),
                date: new Date().toISOString(),
                presentation: {
                    comment: this.description,
                    score: this.selectedStars.toString()
                },
                name: this.contact.props.name,
                username: this.contact.props.email,
                isContact: true
            }
        });

        this.dialogService
            .confirm(
                "Feedback enviado com sucesso!",
                "Sua mensagem foi enviada para sua contabilidade!",
                "Fechar"
            )
            .subscribe(() => {
                this.resetForm();
            });
    }

    private resetForm(): void {
        this.selectedStars = 0;
        this.description = "";
        this.showChips = false;
        this.chips.forEach((chip) => (chip.selected = false));
    }
}
